import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, ToggleItem } from "./helper";
import { header } from "./header";
import { Fullpage, swiperInit } from "./swiper";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	Fullpage.init();
	swiperInit();
	slideCircleVotesProcedure();
	ToggleItem();
	clickActiveItemVotesCriteria();
	VoteHoverTriggerClick();
	disableThumbFancybox();
	getBadgeWidth();
});
// function getBadgeWidth() {
// 	const $badge = $(".wrap-title-badges .img-badge img");
// 	$badge.each(function () {
// 		const width = $(this).width();
// 		$(this).parent().css("width", width);
// 	});
// }
function disableThumbFancybox() {
	Fancybox.bind("[data-fancybox]", {
		Thumbs: false, // Disable thumbnails
	});
	Fancybox.bind("[data-src*='#modal-result-votes']", {
		on: {
			done: function () {
				$(".fancybox__container .img-badge img").each(function () {
					const width = $(this).width();
					$(this).parent().css("width", width);
				});
			},
		},
	});
}
/*==================== Hover trigger click ====================*/
function VoteHoverTriggerClick() {
	$(".section-votes-structure ul li a").on("mouseenter", function () {
		console.log("🚀 ~ mouseenter ~ mouseenter");
		$(this).trigger("click");
	});
}
/*==================== Click active item votes criteria ====================*/
function clickActiveItemVotesCriteria() {
	$("body").on("click", ".item-click", function () {
		const $this = $(this);
		const tabIndex = $this.data("tab-index");
		$(".section-votes-criteria .item-image").removeClass("active");
		$(".section-votes-criteria .item-toggle[data-tab-index=" + tabIndex + "]")
			.addClass("active")
			.find(".content")
			.slideDown()
			.parent()
			.siblings()
			.removeClass("active")
			.find(".content")
			.slideUp();
		$(".section-votes-criteria .item-image[data-tab-index=" + tabIndex + "]").addClass("active");
	});
}
/*==================== Votes Procedure ====================*/
function slideCircleVotesProcedure() {
	const $item_circle = $(".item-circle");
	$item_circle.on("click", function () {
		const clickedIndex = $(this).data("index");
		$item_circle.each(function () {
			const currentIndex = $(this).data("index");
			let newIndex;
			if (currentIndex === clickedIndex) {
				newIndex = 1;
			} else if (currentIndex < clickedIndex) {
				newIndex = currentIndex + (3 - clickedIndex + 1);
			} else {
				newIndex = currentIndex - clickedIndex + 1;
			}
			$(this).data("index", newIndex).attr("data-index", newIndex);
		});
	});
}
/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
